export const projectIntegrationsTableConfig = {
  DefaultPageSize: 10,
  DefaultPageNumber: 1,
};
